import { render, staticRenderFns } from "./ActItemsTree.vue?vue&type=template&id=4ce3844c"
import script from "./ActItemsTree.vue?vue&type=script&lang=js"
export * from "./ActItemsTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports